import { inject, Injectable, signal } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MatBottomSheetService, RestService, Snackbar } from 'src/app/services';
import { PayloadSendIncidentsSurvey, StructureField } from '../interfaces';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IncidentsReporterSurveyForm {
  // Service injections
  private _translateService = inject(TranslateService); // TODO: EN SSR SELECTED LANGUAGE SERVICE
  private _restService = inject(RestService); // TODO: ESTO CAMBIARA EN SSR
  private _matBottomSheetService = inject(MatBottomSheetService);
  private _snackbarService = inject(Snackbar);
  
  // State signals
  private _markAllFormFieldsAsTouched = signal<boolean>(false);
  
  // Getters
  public markAllFormFieldsAsTouched = this._markAllFormFieldsAsTouched.asReadonly();
  
  // Setters
  public setMarkAllFormFieldsAsTouched(markAsTouched: boolean): void {
    this._markAllFormFieldsAsTouched.set(markAsTouched);
  }

  // Methods
  public submitForm(formGroup: FormGroup, surveyId: number, fieldList: StructureField[] ): void {    
    const payload = this.buildPayload(formGroup, surveyId, fieldList);
        
    this._restService.saveSurvey(payload)
      .subscribe({
        next: (_response) => {
          this.toggleBottomSheet();
          const successMessage = this._translateService.instant('Encuesta enviada con éxito');
          this._snackbarService.showSuccessSnackbar(successMessage);
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error submitting survey:', error);
        
          const errorMessage = this._translateService.instant('Error al enviar la encuesta');
          this._snackbarService.showErrorSnackbar(errorMessage);
        }
      });
  }

  buildPayload(formGroup: FormGroup, 
               surveyId: number, 
               fieldList: StructureField[]
              ): PayloadSendIncidentsSurvey | undefined 
  {
    if (!formGroup) return;

    const data = fieldList.map((field, index) => {
      const formControlName = `${field.type}_${index}`;
      return {
        question: field.title ?? '',
        type: field.type,
        answer: formGroup.get(formControlName)?.value
      };
    });
    
    return {
      survey_id: surveyId.toString(),
      data: data
    }
  }
  
  public markFieldAsTouched(control: AbstractControl | null): void {
    control?.markAsTouched();
    control?.markAsDirty();
  }

  public isInvalidField(control: AbstractControl | null): boolean {
    return !!control && control.invalid && (control.touched || control.dirty);
  }
  
  toggleBottomSheet() {
    this._matBottomSheetService.closeAllMatBottomSheets();
  }
}
